module.exports = __webpack_public_path__ + "Alejandra.png?f0b37c1f90d6a4cf2372eb96979f76d3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/customers/Alejandra.png
// module id = 77
// module chunks = 0